import { render, staticRenderFns } from "./SavedStylesInspectorView.vue?vue&type=template&id=013f3e6a&"
import script from "./SavedStylesInspectorView.vue?vue&type=script&lang=js&"
export * from "./SavedStylesInspectorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports